import { Tooltip } from "@chakra-ui/react";
import { AttachmentIcon } from "@chakra-ui/icons";

type Props = { count?: number };

// Paperclip shown on list rows when an email/template carries attachments.
export default function AttachmentIndicator({ count = 0 }: Props) {
  if (count < 1) return null;

  const label = `${count} attachment${count === 1 ? "" : "s"}`;
  return (
    <Tooltip label={label} placement="top" hasArrow>
      <AttachmentIcon color="fg.subtle" boxSize="12px" aria-label={label} />
    </Tooltip>
  );
}
